if (!customElements.get('custom-subscription-widget')) {
  customElements.define(
    'custom-subscription-widget',
    class CustomSubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.setSellingPlan()   
this.querySelector("[id^='rtx_option_plans_dropdown']").addEventListener("change", () => {
            this.setSellingPlan();
        });

this.querySelectorAll('[name^="selling_plan_select"]').forEach((input) => {
            input.addEventListener("change", () => {
                this.setSellingPlan();
            });
        })
      }

      setSellingPlan() {
const selectedOption = this.querySelector('input[name^="selling_plan_select"]:checked');
        if (selectedOption.value === "onetime") {
            this.querySelector('[name="selling_plan"]').value = "";
        } else {
this.querySelector('[id^="rtx_option_plans_dropdown"]').value;
        }
      }
    }
  );
}
 